exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white-box[data-v-184a8a30]{background-color:#fff;padding:20px;border-radius:10px;box-shadow:0 0 10px #d3d3d3;width:500px;margin:50px auto;position:relative}.logo[data-v-184a8a30]{position:absolute;top:10px;right:10px;width:20px;height:25px}.content[data-v-184a8a30]{display:flex;flex-direction:column;align-items:left;text-align:left}.subtitle[data-v-184a8a30]{font-size:14px;font-weight:700;margin-bottom:8px}.input-group[data-v-184a8a30]{display:flex;flex-direction:column;margin-bottom:16px}.form-control[data-v-184a8a30]{font-size:14px;margin-bottom:8px}.error[data-v-184a8a30]{color:red;font-size:12px;margin-bottom:8px}.btn-primary[data-v-184a8a30]{font-size:14px;padding:6px 12px}.value[data-v-184a8a30]{font-size:16px;margin-top:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/recover/ResetPassword.vue?vue&type=style&index=0&id=184a8a30&prod&scoped=true&lang=css&
// module id = 1520
// module chunks = 0